import { render } from "./LaunchCooperate.vue?vue&type=template&id=745dd5ab&scoped=true"
import script from "./LaunchCooperate.vue?vue&type=script&lang=js"
export * from "./LaunchCooperate.vue?vue&type=script&lang=js"

import "./LaunchCooperate.vue?vue&type=style&index=0&id=745dd5ab&scoped=true&lang=css"

import exportComponent from "D:\\eazyc\\ezDev\\ECS-Cognitive\\cognitive-screening-mobile-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-745dd5ab"]])

export default __exports__